import React from "react";

import StaticPageStyles from "./static_pages.module.css"
import InstagramWarning from "../components/InstagramWarning";

export default function Confidential_policy_en() {
    return (
        <div className={StaticPageStyles.staticPageContainer}>
            <InstagramWarning/>
            <h1>Privacy Policy of LeelaOnline.net</h1>
            <h3>1. Introduction</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>We care about the preservation, integrity, and confidentiality of your data.</li>
                    <li className={StaticPageStyles.staticPageText}>We take all available technical and organizational measures to ensure the preservation, integrity, and confidentiality of your data.</li>
                    <li className={StaticPageStyles.staticPageText}>By using this website, you agree to this privacy policy.</li>
                    <li className={StaticPageStyles.staticPageText}>Please carefully read this policy before starting to use our website.</li>
                </ul>
            </p>

            <h3>2. Types of Data Stored</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}><b>Personal information:</b> Name, email address, etc.</li>
                    <li className={StaticPageStyles.staticPageText}><b>Technical information:</b> IP address, browser type, operating system, page visit data, etc.</li>
                    <li className={StaticPageStyles.staticPageText}><b>Usage information:</b> Data about your actions on the website, such as viewed pages, time spent on the website, game results, etc.</li>
                    <li className={StaticPageStyles.staticPageText}><b>Other data:</b> Any other data that you provide while using our website or services.</li>
                </ul>
            </p>

            <h3>3. Data Storage</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>We store your data only as long as necessary to achieve the purposes for which it was collected or to comply with legal requirements.</li>
                    <li className={StaticPageStyles.staticPageText}>Your data is stored on secure servers that use advanced security technologies.</li>
                </ul>
            </p>

            <h3>4. Data Transfer to Third Parties</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>We do not transfer your data to third parties without your consent, except in the following cases:</li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>Clearly indicated when entering data</li>
                        <li className={StaticPageStyles.staticPageText}>Explicitly listed in this policy</li>
                        <li className={StaticPageStyles.staticPageText}>Required by applicable law</li>
                    </ul>
                    <li className={StaticPageStyles.staticPageText}>Your data may be transferred to third-party service providers to ensure the operation of the website and its services (for example, payment processing)</li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>We carefully review all service providers to ensure that their privacy policies align with ours.</li>
                    </ul>
                    <li className={StaticPageStyles.staticPageText}>Data transferred to third parties</li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}><b>Pseudonym:</b> Your pseudonym is your public representation and is used to present you to other conductors, players, and visitors of the website.</li>
                        <li className={StaticPageStyles.staticPageText}><b>Names and descriptions of game cards:</b> Visible to players of your games via a unique game link</li>
                        <li className={StaticPageStyles.staticPageText}><b>Uploaded game board images:</b> Visible to players of your games via a unique game link</li>
                        <li className={StaticPageStyles.staticPageText}><b>Uploaded music files for in-game soundtracks:</b> Played on the player's side upon request</li>
                        <li className={StaticPageStyles.staticPageText}><b>Data entered in the "Player Request" form of the game board:</b> Visible to the player of that game via a unique game link</li>
                        <li className={StaticPageStyles.staticPageText}><b>Game name and player name entered when creating the game:</b> Visible to the player of that game via a unique game link</li>
                        <li className={StaticPageStyles.staticPageText}>**Game player - any person who has been given a unique link to the game</li>
                    </ul>
                </ul>
            </p>

            <h3>5. Use of Data</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>We do not use your data for any purposes other than ensuring the game process, improving, and developing our product.</li>
                    <li className={StaticPageStyles.staticPageText}>Your email address may be used to contact you if necessary and if we are unable to contact you in any other way.</li>
                    <li className={StaticPageStyles.staticPageText}>Your email address may be used to notify you about important or critical changes in the functionality of the product.</li>
                </ul>
            </p>

            <h3>6. Restricted Access to Data</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>LeelaOnline employees' access to your data is granted only to a limited group of technical specialists who need it for the development and improvement of the product or for analyzing technical issues.</li>
                    <li className={StaticPageStyles.staticPageText}>LeelaOnline employees with access to your data are prohibited from using it for any purposes other than performing work related to the development and improvement of the product or analyzing technical issues.</li>
                    <li className={StaticPageStyles.staticPageText}>LeelaOnline employees with access to your data are prohibited from sharing it in any form outside of the group of people who have access to it.</li>
                </ul>
            </p>

            <h3>7. Ways to Protect Your Data:</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}><b>Username and password:</b> Data that is not transferred to third parties is available to the user only after entering the correct username and password.</li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>Do not share your password with anyone.</li>
                        <li className={StaticPageStyles.staticPageText}>Use a sufficiently complex and long password.</li>
                        <li className={StaticPageStyles.staticPageText}>No representative of LeelaOnline will ever ask you to provide your password.</li>
                        <li className={StaticPageStyles.staticPageText}>We are not responsible for the preservation, integrity, and confidentiality of your data in the event that you provide your password to third parties in any form, explicit or implicit.</li>
                    </ul>
                    <li className={StaticPageStyles.staticPageText}><b>Unique link:</b> Each game and the data available in it are protected by a unique code in the link.</li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>The link has a very high level of protection, and it is almost impossible to guess or deduce.</li>
                        <li className={StaticPageStyles.staticPageText}>By sharing the link with third parties, you are essentially granting access to the data available in the game process, whether entered already or to be entered in the future.</li>
                    </ul>
                </ul>
            </p>

            <h3>8. Your Rights</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>You have the right to:</li>
                    <ul>
                        <li className={StaticPageStyles.staticPageText}>Receive information about the processing of your personal data.</li>
                        <li className={StaticPageStyles.staticPageText}>Request the correction or deletion of your personal data.</li>
                        <li className={StaticPageStyles.staticPageText}>Restrict the processing of your data.</li>
                        <li className={StaticPageStyles.staticPageText}>Withdraw your consent to the processing of data.</li>
                    </ul>
                    <li className={StaticPageStyles.staticPageText}>In the case of a request for deletion, restriction, or withdrawal of consent for the processing of personal data, your account may be deleted without the possibility of recovery, and access to certain parts of the site will be restricted.</li>
                </ul>
            </p>

            <h3>9. Cookies</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>We use cookies to improve your experience on our website.
                        Cookies help us analyze traffic, remember your preferences, and settings.</li>
                </ul>
            </p>

            <h3>10. Changes to This Policy</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>We reserve the right to make changes to this policy without prior notice. Changes will be communicated via email to users' email addresses.</li>
                </ul>
            </p>

            <h3>11. Contact Information</h3>
            <p className={StaticPageStyles.staticPagePara}>
                <ul>
                    <li className={StaticPageStyles.staticPageText}>If you have any questions or comments about this privacy policy, please contact us via email.</li>
                    <a href={"mailto:support@leelaonline.net"}>support@leelaonline.net</a>
                </ul>
            </p>

        </div>
    )
}